import { render, staticRenderFns } from "./faqs.vue?vue&type=template&id=5ef2e779"
import script from "./faqs.vue?vue&type=script&lang=js"
export * from "./faqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Faqs: require('/home/runner/work/platform/platform/packages/client/src/components/elements/contact/Faqs.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
